import { ReactNode, useState } from 'react';
import { FunctionRuntime, HookType } from '@rossum/api-client/hooks';
import { IconPhotoOff } from '@rossum/ui/icons/tabler';
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Stack,
  SvgIcon,
  Typography,
} from '@rossum/ui/material';
import { getIcon } from '../../lib/helpers';

type Props = {
  type: HookType;
  runtime: FunctionRuntime | undefined;
  handleClick: () => void;
  name: string;
  description: ReactNode;
  imageUrl: string | null;
  dataCy?: string;
};

export const RossumStoreTile = ({
  type,
  runtime,
  imageUrl,
  handleClick,
  name,
  description,
  dataCy,
}: Props) => {
  const [isError, setIsError] = useState(false);

  return (
    <Card sx={{ height: '100%' }}>
      <CardActionArea
        data-cy={dataCy}
        onClick={() => handleClick()}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          height: '100%',
        }}
      >
        {isError ? (
          <CardMedia
            sx={{
              justifySelf: 'center',
              aspectRatio: '905 / 312',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <SvgIcon
              fontSize="xLarge"
              color="disabled"
              sx={{ alignSelf: 'center' }}
            >
              <IconPhotoOff />
            </SvgIcon>
          </CardMedia>
        ) : (
          <CardMedia
            component="img"
            image={imageUrl ?? undefined}
            alt={name}
            sx={{ p: '1px', aspectRatio: '905 / 312' }}
            onError={() => setIsError(true)}
          />
        )}
        <CardContent>
          <Stack direction="row" spacing={1} mb={1}>
            {getIcon(type, runtime, {}, { title: '' })}
            <Typography gutterBottom variant="h6" component="div">
              {name}
            </Typography>
          </Stack>
          {typeof description === 'string' ? (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {description}
            </Typography>
          ) : (
            description
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
